var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isEditable)?[_c('editor',{ref:"editor",class:( _obj = {'text-editor': true}, _obj[_vm.textClass] = true, _obj['is-editable'] =  _vm.isEditable, _obj ),attrs:{"text":_vm.value,"options":_vm.options},on:{"edit":_vm.updateRichText}})]:[(_vm.showPlainText)?_c('div',{class:_vm.textClass,domProps:{"innerHTML":_vm._s(_vm.value)}},[_vm._v(_vm._s(_vm.value))]):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }